import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Trash2, Inbox as InboxIcon } from "lucide-react";
import { api, formatDate } from "../../lib/api";

const MessageItem = ({ m, onOpen, onDelete, open }) => (
  <div className={`border ${m.read ? "border-white/10" : "border-primary/50"} bg-card`} data-testid={`message-item-${m.id}`}>
    <button onClick={() => onOpen(m)} className="w-full text-left p-5 flex items-center justify-between gap-4" data-testid={`message-open-${m.id}`}>
      <div className="min-w-0">
        <p className="font-semibold truncate">{!m.read && <span className="inline-block w-2 h-2 bg-primary rounded-full mr-2" />}{m.from_name}{m.company && <span className="text-white/50 font-normal"> · {m.company}</span>}</p>
        <p className="text-sm text-white/50 truncate mt-1">{m.body}</p>
      </div>
      <span className="text-xs text-white/40 shrink-0">{formatDate(m.created_at)}</span>
    </button>
    {open && (
      <div className="px-5 pb-5 border-t border-white/10 pt-5">
        <p className="whitespace-pre-line text-white/80">{m.body}</p>
        <div className="flex flex-wrap items-center gap-4 mt-6 text-sm">
          <a href={`mailto:${m.from_email}`} className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-4 py-2 font-bold uppercase text-xs tracking-wider" data-testid={`message-reply-${m.id}`}><Mail size={14} /> Reply to {m.from_email}</a>
          {m.phone && <span className="text-white/60">{m.phone}</span>}
          <button onClick={() => onDelete(m)} className="ml-auto text-white/50 hover:text-red-400 inline-flex items-center gap-1" data-testid={`message-delete-${m.id}`}><Trash2 size={14} /> Delete</button>
        </div>
      </div>
    )}
  </div>
);

export const Inbox = () => {
  const [messages, setMessages] = useState(null);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    api.get("/messages/me").then((r) => setMessages(r.data));
  }, []);

  const onOpen = async (m) => {
    setOpenId(openId === m.id ? null : m.id);
    if (!m.read) {
      await api.post(`/messages/${m.id}/read`);
      setMessages((list) => list.map((x) => (x.id === m.id ? { ...x, read: true } : x)));
    }
  };

  const onDelete = async (m) => {
    await api.delete(`/messages/${m.id}`);
    setMessages((list) => list.filter((x) => x.id !== m.id));
    toast.success("Message deleted");
  };

  if (messages === null) return <p className="label-xs">Loading…</p>;
  if (!messages.length) {
    return (
      <div className="border border-dashed border-white/15 p-16 text-center" data-testid="inbox-empty">
        <InboxIcon className="mx-auto text-white/20" size={48} />
        <p className="font-display text-2xl mt-6">No messages yet</p>
        <p className="text-white/50 text-sm mt-2">When casting teams use your contact form, their messages appear here.</p>
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid="inbox-list">
      {messages.map((m) => <MessageItem key={m.id} m={m} open={openId === m.id} onOpen={onOpen} onDelete={onDelete} />)}
    </div>
  );
};
